interface PartnerTestimonial {
  width: number | string;
  height: number | string;
  color: string;
}

export function QuoteIcon({
  width = 70,
  height = 60,
  color = "#DDD9EE",
}: PartnerTestimonial) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 70 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.73342 59.5C1.06675 46.8333 -1.97281 18.6703 5.73342 10C13.7327 1 21.7335 0 29.7335 0V11C27.4002 11.1667 22.1335 12.1 19.7335 14.5C16.7335 17.5 14.2335 23 15.2335 34.5H30.2335V59L3.73342 59.5ZM43.1318 59.5C40.4651 46.8333 37.4256 18.6703 45.1318 10C53.1311 1 61.1319 0 69.1319 0V11C66.7985 11.1667 61.5319 12.1 59.1319 14.5C56.1319 17.5 53.6319 23 54.6319 34.5H69.6319V59L43.1318 59.5Z"
        fill={color}
      />
    </svg>
  );
}
